<template>

  <div v-if="status.ready" class="vue-search-form">

    <search-form 
      :params="params"
      @set-param="setParam"
      @set-filter="setFilter"
      @do-search="doSearch">
    </search-form>

    <div v-if="!status.error">

      <search-results 
        v-if="result"
        :result="result"
        :params="params"
        :sat="config.sat"
        :busy="status.busy"
        @search="doSearch"
        @remove="removeURL">
      </search-results>

      <div v-if="status.busy && !result">
        Getting search results...
      </div>
      
    </div>
    <div v-else class="grid-x align-middle" style="margin-top: 1.5rem">
      <div class="cell shrink">
        <span 
          v-html="$icons.get('error', 'xlarge red')"
          style="margin-right: 1rem">
        </span>
      </div>
      <div class="cell auto">
        An error has occurred: {{ status.error }}
      </div>
    </div>

  </div>
</template>

<script>
import {_} from 'vue-underscore'
import axios from 'axios'
import SearchForm from '@/SearchForm.vue'
import SearchResults from '@/SearchResults.vue'

export default {
  name: 'app',
  components: {
    SearchForm, SearchResults
  },
  data () {
    return {
      status: {
        ready: false,
        busy: false,
        error: false
      },
      params: {
        query: '',
        page: 1,
        filters: [],
        operator: 'AND',
        items_per_page: 25
      },
      result: false,
      show_filters: false
    }
  },
  methods: {
    init () {
      try {

        if ('filters' in this.config) {
          let params = this.params
          _.each(this.config.filters, function (item) {
            if ('defaults' in item) {
              params.filters.push({
                id: item.id,
                values: item.defaults
              })
            }
          })
        }

        this.status.ready = true

        const query = this.getQuery()
        if (query) {
          this.params.query = query
          this.doSearch()
        }
      } catch (e) {
        this.status.error = 'An error occurred, search is currently not available.'
      }
    },
    /** 
     * Selected values for a given filter
     */
    selectedFilterValues (id) {
      let item = _.find(this.params.filters, function(item) {
        return item.id == id
      })
      return (item ? item.values : [])
    },
    doSearch (reset) {

      // If new query, reset page to 1
      if (reset) {
        this.setParam('page', 1)
      }

      this.setQuery(this.params.query)

      if (!this.status.busy) {
        this.status.busy = true
        axios.post(this.config.url + '/search', {
          params: this.params,
          responseType: 'json'
        })
        .then(function(response) {
          if (response.data.success) {
            this.result = response.data.result
            if (reset && this.result.facets) {
              this.facets = this.result.facets
            }
            this.status.error = false
          } else {
            this.status.error = response.data.message
          }
        }.bind(this))
        .catch(function (error) {
          this.status.error = error
          console.log(error)
        }.bind(this))
        .finally(function () {
          this.status.busy = false
        }.bind(this))
      }
    },
    /** 
     * Get query in url
     */
    getQuery () {
      const uri = window.location.search.substring(1)
      const params = new URLSearchParams(uri)
      return params.get('q')
    },
    /** 
     * Set query in url
     */
    setQuery (str) {
      const uri = new URL(window.location.href)
      uri.searchParams.set('q', encodeURIComponent(str))
      if (history.pushState) {
        history.pushState(null, null, uri)
      } else {
        location.href = uri
      }
    },
    /** 
     * Set filter
     * @param object
     */
    setFilter (data) {
      let index = _.findIndex(this.params.filters, function(item) {
        return item.id == data.id
      })

      if (index === false) {
        this.params.filters.push(data)
      } else {
        this.params.filters[index].values = data.values
      }
    },
    /** 
     * Set parameter
     * @param object
     */
    setParam (param) {
      this.params[param.name] = param.value
    }
  },
  computed: {
    config () {
      return this.$options.config
    }
  },
  mounted () {
    this.init()
  }
}
</script>
